import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Itens({ commit, state }, params) {
    let tipo = params.tipo ? params.tipo : state.tipo;
    params.tipo = params.tipo ? params.tipo.id : state.tipo.id;
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("wkf/autorizacao", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        commit("setTipo", tipo);
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async Update({ commit, state }, params) {
    const headers = Helpers.iniciarRequisicao();
    params.tipo = state.tipo.id;
    return await api({
      method: "put",
      url: "wkf/autorizacao/" + params.id,
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
      })
      .catch(() => {
        Helpers.logout();
      });
  }
};
